import styled, { css } from 'styled-components';
import { Modal } from '@prezi/common-components';
const ResponsiveModal = styled(Modal).withConfig({
  displayName: "ResponsiveModal",
  componentId: "hex9n9-0"
})(["overflow:hidden;border-radius:4px;", " max-height:calc(100vh - 48px);transition:height 500ms;transition-timing-function:cubic-bezier(0.8,0,0.2,1);background:white;"], p => p.height && css(["height:", "px;"], p.height));
export default ResponsiveModal;